import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentPage } from "../redux/slices/filterSlice";
import Tags from "../components/Tags";
import Sort from "../components/Sort";
import Pizza from "../components/Pizza";
import PizzaSkeleton from "../components/Pizza/PizzaSkeleton";
import Pagination from "../components/Pagination";

// Lesson 16
// import qs from "qs";
// import { useNavigate } from "react-router-dom";

export default function Home({ searchValue }) {
  const dispatch = useDispatch();

  // const navigate = useNavigate(); Lesson 16

  const { tagId, sortType, currentPage } = useSelector((state) => state.filter);

  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const onChangePage = (number) => {
    dispatch(setCurrentPage(number));
  };

  //Lesson 16
  //
  // useEffect(() => {
  //   if (window.location.search) {
  //     const params = qs.parse(window.location.search.substring(1));
  //     const sort = sorts.find(
  //       (obj) => obj.sortProperty === params.sortProperty
  //     );

  //     dispatch(
  //       setFilters({
  //         ...params,
  //         sort,
  //       })
  //     );
  //   }
  // }, []);

  // useEffect(() => {
  //   const queryString = qs.stringify({
  //     sortProperty: sortType.sortProperty,
  //     tagId,
  //     currentPage,
  //   });

  //   navigate(`?${queryString}`);
  // }, [tagId, sortType.sortProperty, currentPage]);

  const fetchPizzas = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `https://638fd70e00885e7e7949a3c0.mockapi.io/items?page=${currentPage}&limit=4&sortBy=${
          sortType.sortProperty[0] === "-"
            ? sortType.sortProperty.slice(1) + "&order=asc"
            : sortType.sortProperty + "&order=desc"
        }${tagId > 0 ? "&category=" + tagId : ""}
      ${searchValue ? "&search=" + searchValue : ""}`
      );

      setItems(res.data);
    } catch (error) {
      alert(`ERROR: ${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPizzas();
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, [tagId, sortType, searchValue, currentPage]);

  return (
    <div className="container">
      <div className="content__top">
        {/*-- Tags --*/}
        <Tags />
        <Sort />
      </div>
      <h2 className="content__title">All Pizzas</h2>
      <div className="content__items">
        {isLoading
          ? [...new Array(4)].map((_, index) => <PizzaSkeleton key={index} />)
          : items.map((pizza) => <Pizza key={pizza.id} {...pizza} />)}
      </div>
      <Pagination currentPage={currentPage} onChangePage={onChangePage} />
    </div>
  );
}
